import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { useServerFn } from "@tanstack/react-start";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { claimCoachAccount } from "@/lib/coach-portal.functions";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "sonner";

export const Route = createFileRoute("/coach-access/$token")({
  head: () => ({ meta: [{ title: "Aktivera coach-konto — Inkubera" }] }),
  component: ClaimPage,
});

function ClaimPage() {
  const { token } = Route.useParams();
  const claim = useServerFn(claimCoachAccount);
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault();
    if (password.length < 8) return toast.error("Minst 8 tecken.");
    if (password !== confirm) return toast.error("Lösenorden matchar inte.");
    setBusy(true);
    try {
      const res = await claim({ data: { token, password } });
      const { error } = await supabase.auth.signInWithPassword({
        email: res.email,
        password,
      });
      if (error) throw error;
      toast.success("Välkommen!");
      navigate({ to: "/coach-portal" });
    } catch (err) {
      toast.error(err instanceof Error ? err.message : "Något gick fel.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4 py-12">
      <form onSubmit={handleSubmit} className="w-full max-w-md rounded-2xl border border-border bg-card p-8 space-y-5">
        <div>
          <div className="text-xs uppercase tracking-[0.18em] text-muted-foreground mb-2">Inkubera · Coach</div>
          <h1 className="font-display text-2xl">Aktivera ditt konto</h1>
          <p className="text-sm text-muted-foreground mt-2">
            Sätt ett lösenord så aktiverar vi din coach-portal och loggar in dig.
          </p>
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pw">Lösenord</Label>
          <Input id="pw" type="password" value={password} onChange={(e) => setPassword(e.target.value)} required minLength={8} />
        </div>
        <div className="space-y-1.5">
          <Label htmlFor="pw2">Bekräfta lösenord</Label>
          <Input id="pw2" type="password" value={confirm} onChange={(e) => setConfirm(e.target.value)} required minLength={8} />
        </div>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? "Aktiverar…" : "Aktivera & logga in"}
        </Button>
      </form>
    </div>
  );
}
